import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../constant/baseurl";
import { showLoading } from "../slice/loadingSlice";
import { apiCall } from "../../api";

const createAccountAsyncThunk = (method, type, contentType, url) =>
  createAsyncThunk(type, async (payload, thunkAPI) => {
    const { data } = payload;
    const { dispatch } = thunkAPI;
    // console.log("data:::", data);
    // const token = localStorage.getItem("token");
    // During MFA login only the temporary session token exists; once logged in
    // (e.g. enabling MFA for a newly created user) use the real login token.
    const token = sessionStorage.getItem('sessiontoken') || localStorage.getItem("token");
    const apiRequest = {
      method: method,
      headers: token
        ? {
            "Content-Type": contentType,
            Authorization: "Token " + token,
          }
        : { "Content-Type": contentType },
      url: `${baseUrl}${url}`,
      data,
    };

    try {
      dispatch(showLoading.actions.toggleLoading(true));
      const res = await apiCall(apiRequest, dispatch);
      const response = res.data;

      dispatch(showLoading.actions.toggleLoading(false));

      if (response.statusFlag === true) {
        // console.log(`${type}:::::`, response);
        return response;
      } else {
        // console.error(`account action - ${type}`, response);

        // Check if there is an error code in the response
        const errorCode = response.message;

        // You can throw a custom error with the error code
        throw new Error(errorCode);
      }
    } catch (error) {
      dispatch(showLoading.actions.toggleLoading(false));
      throw error;
    }
  });

export const enableMfa = createAccountAsyncThunk(
  "post",
  "enableMfa",
  "application/json",
  "valiantinfo_admin/mfa_authentication/enable_mfa/"
);

export const registerMfa = createAccountAsyncThunk(
    "post",
    "registerMfa",
    "application/json",
    "valiantinfo_admin/mfa_authentication/register_mfa/"
  );

export const verifyMfaAuthentication = createAccountAsyncThunk(
    "post",
    "verifyMfaAuthentication",
    "application/json",
    "valiantinfo_admin/mfa_authentication/verify_mfa_authentication/"
  );